import { formGroupToFormData } from '@dss-libs/shared/utility/common-utilities';
import { ICreateOrderFormModel } from '@dss-libs/portal/type/portal-types';

export function mapCreateOrderFormToFormData(model: ICreateOrderFormModel, documents: FormData | null): FormData {
  const { recipientInformation, orderSettings, orderMessage } = model;
  const formData = formGroupToFormData({
    Name: orderSettings.name,
    ExpirationPeriod: orderSettings.expirationPeriod,
    ReminderInterval: orderSettings.reminderInterval,
    SigningMethod: orderSettings.signingMethod,
    VerificationMethod: orderSettings.verificationMethod,
    EmailSubject: orderMessage.emailSubject,
    EmailBody: orderMessage.emailBody,
    RequireSignerAuthentication: orderSettings.requireSignerAuthentication,
    Language: orderSettings.language,
    Steps: recipientInformation.steps.map(({ recipients }) => ({
      Recipients: recipients.map(({ name, email, task, phone }) => ({
        Name: name,
        Email: email,
        Task: task,
        PhoneNumber: phone.phoneNumber,
        PhoneCountryCode: phone.countryCode,
      })),
    })),
    NotificationRecipients: orderSettings.notificationRecipients.map(({ name, email }) => ({
      Name: name,
      Email: email,
    })),
  });
  for (const file of documents?.values() ?? []) {
    formData.append('Documents', file);
  }
  return formData;
}
